import { render } from "./UserChatPopUp.vue?vue&type=template&id=29e0d8a3&scoped=true"
import script from "./UserChatPopUp.vue?vue&type=script&lang=js"
export * from "./UserChatPopUp.vue?vue&type=script&lang=js"

import "./UserChatPopUp.vue?vue&type=style&index=0&id=29e0d8a3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e0d8a3"]])

export default __exports__